
        import type { DefaultTemplateRootProps, TemplateResult } from 'Components/types';
type verifyFitmentRTRootProps = DefaultTemplateRootProps;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function verifyFitmentRT(): TemplateResult<verifyFitmentRTRootProps> {
    return this.isVehicleSelected ? _createElement('li', {
        'className': 'cm_vehicle-widget cm_vehicle-widget__verify-fitment',
        'key': '0'
    }, this.fits === 'yes' ? [
        [_createElement('svg', {
                'className': 'cm_icon cm_icon-green-check',
                'width': '16',
                'height': '16',
                'viewBox': '0 0 16 16',
                'xmlns': 'http://www.w3.org/2000/svg',
                'key': '1480'
            }, _createElement('path', {
                'd': 'M3.5 8.5L6.5 11.5L12.5 5.5',
                'fill': 'none',
                'stroke': 'green',
                'strokeWidth': '2.5',
                'strokeLinecap': 'round',
                'strokeLinejoin': 'round'
            }))],
        ' ',
        _translate(`verify_fitment_fits`)
    ] : null, this.fits === 'no' ? [
        [_createElement('svg', {
                'className': 'cm_icon cm_icon-red-cross',
                'width': '16',
                'height': '16',
                'viewBox': '0 0 16 16',
                'xmlns': 'http://www.w3.org/2000/svg',
                'key': '5340'
            }, _createElement('line', {
                'x1': '4',
                'y1': '4',
                'x2': '12',
                'y2': '12',
                'stroke': '#E53935',
                'strokeWdth': '2',
                'strokeLinecap': 'round'
            }), _createElement('line', {
                'x1': '12',
                'y1': '4',
                'x2': '4',
                'y2': '12',
                'stroke': '#E53935',
                'strokeWidth': '2',
                'strokeLinecap': 'round'
            }))],
        ' ',
        _translate(`verify_fitment_does_not_fit`)
    ] : null, this.fits === 'aggressive' ? [
        [_createElement('svg', {
                'className': 'cm_icon cm_icon-dot',
                'width': '16',
                'height': '16',
                'viewBox': '0 0 16 16',
                'xmlns': 'http://www.w3.org/2000/svg',
                'key': '9920'
            }, _createElement('circle', {
                'cx': '8',
                'cy': '8',
                'r': '4'
            }))],
        ' ',
        _translate(`verify_fitment_aggressive_fits`)
    ] : null, _createElement('a', {
        'className': 'cm_verify-fitment_change-button',
        'href': '#',
        'onClick': this.openDialog
    }, 'Change vehicle')) : null;
}
        export const componentNames = []